<div class="row" *ngIf="!showForm">
    <div *ngIf="isOwner" class="col-md-6">
        <button 
            class="ds-btn ds-btn-primary ds-btn-small"
            [ngClass]="{'pull-right': !isArabic , 'pull-left' :isArabic }"
            [innerText]="'UserProfile.Agent.AddAgent' | translate"
            (click)="addAgentClick()">
        </button>
    </div>
    <div class="col-md-6">
        <app-list-filter (search)="updateSearchText($event)"></app-list-filter>
    </div>
</div>

<form [formGroup]="form" *ngIf="showForm">
    <div class="row">
        <div class="col-md-6" *ngIf="form.controls.IdentityType">
            <div class="form-group" *ngIf="isNew">
            <label class="form-control-label-required">{{("UserProfile.IdType" | translate).labelText}}</label>
            <div class="row">
                <div class="col-md-6">
                <bs-ng-radiobox
                    formControlName="IdentityType"
                    identifier="IdTypeIdNumber"
                    key="UserProfile.IdType.IdNumber"
                    name="IdType"
                    [set]="'IdNumber'"
                    (change)="onIdTypeChange($event)">
                </bs-ng-radiobox>
                </div>
                <div class="col-md-6">
                <bs-ng-radiobox
                    formControlName="IdentityType"
                    identifier="IdTypePassport"
                    key="UserProfile.IdType.Passport"
                    name="IdType"
                    [set]="'Passport'"
                    (change)="onIdTypeChange($event)">
                </bs-ng-radiobox>
                </div>
            </div>
            </div>
            <div class="form-group" *ngIf="!isNew">
                <app-bs-display
                    key="UserProfile.IdType"
                    [valueText]="('UserProfile.IdType.' + form.controls.IdentityType.value + '.labelText') | translate">
                </app-bs-display>
            </div>
        </div>

        <div class="col-md-6" *ngIf="form.controls.IdNumber">
            <bs-ng-text
                *ngIf="isNew"
                formControlName="IdNumber"
                identifier="IdNumber"
                name="IdNumber"
                key="UserProfile.IdNumber"
                [prefix]="emiratesIdMaskPrefix"
                [mask]="emiratesIdMask"
                (change)="onIDChange()">
            </bs-ng-text>
            <app-bs-display
                *ngIf="!isNew"
                key="UserProfile.IdNumber"
                [valueText]="form.controls.IdNumber.value">
            </app-bs-display>
        </div>

        <div class="col-md-6" *ngIf="form.controls.OTP">
        <bs-ng-text
            formControlName="OTP"
            identifier="OTP"
            name="OTP"
            key="UserProfile.OTP"
            (change)="onOTPChange()">
        </bs-ng-text>
        </div>

        <div class="col-md-6" *ngIf="form.controls.Passport">
            <bs-ng-text
                formControlName="Passport"
                identifier="Passport"
                name="Passport"
                key="UserProfile.Passport"
                maxLength="50"
                (change)="onPassportChange()">
            </bs-ng-text>
        </div>

        <div class="col-md-12" *ngIf="otpAlert">
            <app-bs-alert
            class="has-error is-invalid" 
            [importance]="otpAlertType"
            [alert]="otpAlert">
            </app-bs-alert>
        </div>

        <div class="col-md-6" *ngIf="showControls">
            <app-bs-display 
              *ngIf="!isEditable"
              key="UserProfile.NameAr"
              [valueText]="form.controls.NameAr.value">
            </app-bs-display>
            <bs-ng-text
              *ngIf="isEditable"
              formControlName="NameAr"
              identifier="NameAr"
              name="NameAr"
              key="UserProfile.NameAr"
              maxLength="150">
            </bs-ng-text>
        </div>

        <div class="col-md-6" *ngIf="showControls">
            <app-bs-display
              *ngIf="!isEditable"
              key="UserProfile.NameEn"
              [valueText]="form.controls.NameEn.value">
            </app-bs-display>
            <bs-ng-text
              *ngIf="isEditable"
              formControlName="NameEn"
              identifier="NameEn"
              name="NameEn"
              key="UserProfile.NameEn"
              maxLength="150">
            </bs-ng-text>
        </div>

        <div class="col-md-6" *ngIf="showControls">
            <app-bs-display
                *ngIf="selectedAgent?.IsDefaultAgent || form.controls.IdNumber"
                key="UserProfile.Mobile"
                [valueText]="form.controls.Mobile.value">
            </app-bs-display>
            <bs-ng-text
                *ngIf="!selectedAgent?.IsDefaultAgent && !form.controls.IdNumber"
                formControlName="Mobile"
                identifier="Mobile"
                key="UserProfile.Mobile"
                name="Mobile"
                [minlength]="10"
                [maxlength]="20"
                [mask]="phoneNumberMask">
            </bs-ng-text>
        </div>

        <div class="col-md-6" *ngIf="showControls">
            <app-bs-display
                *ngIf="selectedAgent?.IsDefaultAgent"
                key="UserProfile.Email"
                [valueText]="form.controls.Email.value">
            </app-bs-display>
            <bs-ng-text
                *ngIf="!selectedAgent?.IsDefaultAgent"
                formControlName="Email"
                identifier="Email"
                key="UserProfile.Email"
                name="Email"
                maxLength="200">
            </bs-ng-text>
        </div>

        <div class="col-md-6" *ngIf="showControls">
            <bs-ng-dropdown
              formControlName="PreferedLanguage"
              identifier="PreferedLanguage"
              name="PreferedLanguage"
              key="UserProfile.PreferedLanguage"
              [items]="lookups.Languages"
              [bindLabel]="defaultLookupDisplayProperty">
            </bs-ng-dropdown>
        </div>

        <!--<div class="col-md-6" *ngIf="showControls">
            <div *ngIf="!selectedAgent?.IsDefaultAgent">
                <label class="form-control-label-required">{{("UserProfile.LoginPermission" | translate).labelText}}</label>
                <div class="row">
                    <div class="col-md-6">
                    <bs-ng-radiobox
                        formControlName="LoginPermission"
                        identifier="LoginPermissionGranted"
                        key="UserProfile.LoginPermission.Granted"
                        name="LoginPermission"
                        [set]="true">
                    </bs-ng-radiobox>
                    </div>
                    <div class="col-md-6">
                    <bs-ng-radiobox
                        formControlName="LoginPermission"
                        identifier="LoginPermissionDenied"
                        key="UserProfile.LoginPermission.Denied"
                        name="LoginPermission"
                        [set]="false">
                    </bs-ng-radiobox>
                    </div>
                </div>
            </div>
            <app-detail-display class="col-md-6" *ngIf="selectedAgent?.IsDefaultAgent"
                key="UserProfile.LoginPermission"  
                [value]="(selectedAgent.LoginPermission? 'UserProfile.LoginPermission.Granted':'UserProfile.LoginPermission.Denied')+'.labelText' | translate">
            </app-detail-display>
        </div>-->
    </div>
    <div class="row">
        <div class="col-md-6">
            <button *ngIf="isNew"
                    [innerText]="'Add' | translate"
                    type="submit"
                    class="ds-btn ds-btn-primary ds-btn-small"
                    (click)="save()">
            </button>
            <button *ngIf="!isNew"
                    [innerText]="'Save' | translate"
                    type="submit"
                    class="ds-btn ds-btn-primary ds-btn-small"
                    (click)="save()">
            </button>
            <button [innerText]="'Cancel' | translate"
                    class="ds-btn ds-btn-secondary ds-btn-small m-2"
                    (click)="cancel()">
            </button>
        </div>
    </div>
</form>

<div class="row mt-2">
    <div class="col-12">
      <ul *ngIf="activeAgents && activeAgents.length" class="list-group ds-list-group-default">
        
        <li class="list-group-item ds-list-group-head-default d-flex justify-content-start align-items-center px-2">  
            <app-detail-display *ngIf="isArabic" class="w-mm-50" [value]="" key="UserProfile.NameAr">
            </app-detail-display>
    
            <app-detail-display *ngIf="!isArabic" class="w-mm-50" [value]="" key="UserProfile.NameEn">
            </app-detail-display>

            <app-detail-display *ngIf="isOwner" class="w-mm-30" [value]="" key="UserProfile.LoginPermission">
            </app-detail-display>
        </li>
  
        <li *ngFor="let agent of activeAgents | searchFilter: searchText 
                    | paginate: { id: 'agentsPagination', itemsPerPage: itemsPerPage, currentPage: currentPage }; 
                    let index = index"
              class="list-group-item d-flex justify-content-start align-items-center">
          <div class="ds-list-group-item-head d-flex w-100 p-2"
              [class.ds-list-group-item-head-open]="isCollapsed[index] == false">

            <app-detail-display *ngIf="isArabic" class="w-mm-50" [value]="agent.NameAr"
                (click)="isCollapsed[index] = !isCollapsed[index]">
            </app-detail-display>
  
            <app-detail-display *ngIf="!isArabic" class="w-mm-50" [value]="agent.NameEn"
                (click)="isCollapsed[index] = !isCollapsed[index]">
            </app-detail-display>

            <div class="w-mm-30 pt-1" *ngIf="isOwner">
                <input id="chck_LoginPermission" class="checkbox-gold" 
                    type="checkbox" [(ngModel)]="agent.LoginPermission" (change)="changeLoginPermission($event,agent)" *ngIf="!agent.IsDefaultAgent" />
                <label for="chck_LoginPermission" class="checkbox-label pl-1 pr-1">
                    {{(agent.LoginPermission? 'UserProfile.LoginPermission.Granted':'UserProfile.LoginPermission.Denied')+'.labelText' | translate}}
                </label>
            </div>
  
            <div class="list-group-item-options">
              <ng-container>
                <!--<a *ngIf="isOwner" class="ds-btn-icon" (click)="edit($event,agent)">
                  <i class="fi-register fi-large mx-2"></i>
                </a>-->
                <a class="ds-btn-icon" (click)="delete(agent)" *ngIf="!agent.IsDefaultAgent && isOwner">
                  <i class="fi-close-thick mx-2"></i>
                </a>
              </ng-container>
              <a class="ds-btn-icon ds-btn-bg-bright" [attr.aria-expanded]="!isCollapsed[index]" (click)="isCollapsed[index] = !isCollapsed[index]">
                 <i class="fi-arrow-thin-down"></i>
              </a>
            </div>
          </div>
  
          <div class="list-group-item-details collapse show w-100" [ngbCollapse]="isCollapsed[index] ?? (isCollapsed[index] = true)">
            <div  class="row px-2">
                <app-detail-display *ngIf="!isArabic" class="col-md-6" key="UserProfile.NameAr" [value]="agent.NameAr">
                </app-detail-display>
        
                <app-detail-display *ngIf="isArabic" class="col-md-6" key="UserProfile.NameEn"  [value]="agent.NameEn">
                </app-detail-display>
    
                <app-detail-display *ngIf="agent.Passport" class="col-md-6" key="UserProfile.Passport"  [value]="agent.Passport">
                </app-detail-display>
    
                <app-detail-display *ngIf="agent.IdNumber" class="col-md-6" key="UserProfile.IdNumber"  [value]="agent.IdNumber">
                </app-detail-display>
        
                <app-detail-display class="col-md-6" key="UserProfile.Mobile"  [value]="agent.Mobile">
                </app-detail-display>

                <app-detail-display class="col-md-6" key="UserProfile.Email"  [value]="agent.Email">
                </app-detail-display>

                <app-detail-display class="col-md-6" key="UserProfile.PreferedLanguage"  [value]="agent.PreferedLanguage | lookup:lang">
                </app-detail-display>

                <app-detail-display *ngIf="isOwner" class="col-md-6" key="UserProfile.LoginPermission"  
                    [value]="(agent.LoginPermission? 'UserProfile.LoginPermission.Granted':'UserProfile.LoginPermission.Denied')+'.labelText' | translate">
                </app-detail-display>
            </div>
          </div>
        </li>
  
        <li class="list-group-item d-flex justify-content-start align-items-center px-2">
            <div class="w-mm-50 pt-1"
                  *ngIf="activeAgents.length > itemsPerPage">
              <p>
                {{ ("ItemsCount" | translate) +": "+ (activeAgents| searchFilter: searchText).length  }} 
              </p>
            </div>
            <div class="w-mm-50 pagination_in">
              <div class="pagination">
                <pagination-controls 
                    id="agentsPagination"
                    previousLabel="{{'PaginationPreviousLabel' | translate}}"
                    nextLabel="{{'PaginationNextLabel' | translate }}"
                    (pageChange)="currentPage = $event"
                    [autoHide]="true"
                    [responsive]="true"
                    [maxSize]="3">
                </pagination-controls>
              </div>
            </div>
        </li>
      </ul>
    </div>
</div>
  
<app-list-validation
    name="agentsList"
    [formGroup]="mainForm"
    [items]="activeAgents"
    [min]="1"
    [isEditable]="true"
    minValidationMsgKey="UserProfile.EmptyAgentsMessage"> 
</app-list-validation>